import { ctx, noop } from "@welshman/lib";
import { Negentropy, NegentropyStorageVector } from "./Negentropy.js";
const createSubId = (prefix) => `${prefix}-${Math.random().toString().slice(2, 10)}`;
export class Executor {
    target;
    constructor(target) {
        this.target = target;
    }
    subscribe(filters, { onEvent, onEose } = {}) {
        let closed = false;
        const id = createSubId("REQ");
        const eventListener = (url, subid, e) => {
            if (subid === id) {
                ctx.net.onEvent(url, e);
                onEvent?.(url, e);
            }
        };
        const eoseListener = (url, subid) => {
            if (subid === id) {
                onEose?.(url);
            }
        };
        this.target.on("EVENT", eventListener);
        this.target.on("EOSE", eoseListener);
        this.target.send("REQ", id, ...filters);
        return {
            unsubscribe: () => {
                if (closed)
                    return;
                this.target.send("CLOSE", id).catch(noop);
                this.target.off("EVENT", eventListener);
                this.target.off("EOSE", eoseListener);
                closed = true;
            },
        };
    }
    publish(event, { verb = "EVENT", onOk, onError } = {}) {
        const okListener = (url, id, ok, message) => {
            if (id === event.id) {
                if (ok) {
                    ctx.net.onEvent(url, event);
                }
                onOk?.(url, id, ok, message);
            }
        };
        const errorListener = (url, id, ...payload) => {
            if (id === event.id) {
                onError?.(url, id, ...payload);
            }
        };
        this.target.on("OK", okListener);
        this.target.on("ERROR", errorListener);
        this.target.send(verb, event);
        return {
            unsubscribe: () => {
                this.target.off("OK", okListener);
                this.target.off("ERROR", errorListener);
            },
        };
    }
    diff(filter, events, { onMessage, onError, onClose } = {}) {
        let closed = false;
        const id = createSubId("NEG");
        const storage = new NegentropyStorageVector();
        const neg = new Negentropy(storage, 50_000);
        for (const event of events) {
            storage.insert(event.created_at, event.id);
        }
        storage.seal();
        const msgListener = async (url, negid, msg) => {
            if (negid === id) {
                const [newMsg, have, need] = await neg.reconcile(msg);
                onMessage?.(url, { have, need });
                if (newMsg) {
                    this.target.send("NEG-MSG", id, newMsg);
                }
                else {
                    close();
                }
            }
        };
        const errListener = (url, negid, msg) => {
            if (negid === id) {
                onError?.(url, msg);
            }
        };
        const close = () => {
            if (closed)
                return;
            this.target.send("NEG-CLOSE", id).catch(noop);
            this.target.off("NEG-MSG", msgListener);
            this.target.off("NEG-ERR", errListener);
            closed = true;
            onClose?.();
        };
        this.target.on("NEG-MSG", msgListener);
        this.target.on("NEG-ERR", errListener);
        neg.initiate().then((msg) => {
            this.target.send("NEG-OPEN", id, filter, msg);
        });
        return {
            unsubscribe: close,
        };
    }
}
//# sourceMappingURL=Executor.js.map